import React from 'react';
import {Paper, Stack} from "@mui/material";
import {styled} from "@mui/material/styles";
import {useNavigate} from "react-router-dom";

const CategoryName = styled(Paper)(({ theme }) => ({
    // backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
    // ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.primary,
}));
const OneCategory = (props) => {
    let navigate = useNavigate();
    function myttt()
        {
            navigate(props.urlx);
        }
    return (
        <CategoryName>
            <Stack spacing={0}>
                <div className="myCardCategory-image ">
                    <a href="">
                    <img onClick={myttt} className="CenterToCenter " src={props.img}/>
                    </a>
                </div>
                <div className="myCardCategory-text">{props.label}</div>

                {/*{props.admin==true?( <div>*/}
                {/*    ddd*/}
                {/*</div>):(<></>)}*/}

            </Stack>
        </CategoryName>
    );
};

export default OneCategory;